import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAttendanceList,
  loadAttendanceByUserId,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import { useParams } from "react-router-dom";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import AttendanceCalendar from "./AttendanceCalender";
import dayjs from "dayjs";
import getUserFromToken from "../../utils/getUserFromToken";

// function CustomTable({ list, loading }) {
// 	const [columnsToShow, setColumnsToShow] = useState([]);

// 	const columns = [
// 		{
// 			id: 1,
// 			title: "S.No",
// 			dataIndex: "serial",
// 			key: "serial",
// 		},
// 		{
// 			id: 2,
// 			title: "Name",
// 			dataIndex: "user",
// 			key: "user",
// 			render: ({ firstName, lastName }) => firstName + " " + lastName,
// 		},

// 		{
// 			id: 3,
// 			title: "inTime",
// 			dataIndex: "inTime",
// 			key: "inTime",
// 			// render: (inTime) => dayjs(inTime).format("DD-MM-YYYY, h:mm A"),
// 			render: (inTime) => inTime ? dayjs(inTime).utc().format("DD-MM-YYYY, h:mm A") : "Not Available",

// 		},

// 		{
// 			id: 4,
// 			title: "Out Time",
// 			dataIndex: "outTime",
// 			key: "outTime",
// 			// render: (outTime) => dayjs(outTime).format("DD-MM-YYYY, h:mm A"),
// 			render: (outTime) => outTime ? dayjs(outTime).utc().format("DD-MM-YYYY, h:mm A") : "Not Available",

// 		},
// 		{
// 			id: 4,
// 			title: "In Status",
// 			dataIndex: "inTimeStatus",
// 			key: "inTimeStatus",
// 			render: (inTimeStatus) => {
// 				// use Tag component from antd to show status in different colors like green, red, yellow etc based on the status value
// 				if (inTimeStatus === "Late") {
// 					return <Tag color='red'>{inTimeStatus.toUpperCase()}</Tag>;
// 				} else if (inTimeStatus === "Early") {
// 					return <Tag color='blue'>{inTimeStatus.toUpperCase()}</Tag>;
// 				} else if (inTimeStatus === "On Time") {
// 					return <Tag color='green'>{inTimeStatus.toUpperCase()}</Tag>;
// 				} else {
// 					return <Tag style={{ color: "orange" }}>NONE</Tag>;
// 				}
// 			},
// 		},
// 		{
// 			id: 5,
// 			title: "Out Status",
// 			dataIndex: "outTimeStatus",
// 			key: "outTimeStatus",
// 			render: (outTimeStatus) => {
// 				// use Tag component from antd to show status in different colors like green, red, yellow etc based on the status value
// 				if (outTimeStatus === "Late") {
// 					return <Tag color='red'>{outTimeStatus.toUpperCase()}</Tag>;
// 				} else if (outTimeStatus === "Early") {
// 					return <Tag color='blue'>{outTimeStatus.toUpperCase()}</Tag>;
// 				} else if (outTimeStatus === "On Time") {
// 					return <Tag color='green'>{outTimeStatus.toUpperCase()}</Tag>;
// 				} else {
// 					return <Tag style={{ color: "orange" }}>NONE</Tag>;
// 				}
// 			},
// 		},
// 		// {
// 		// 	id: 7,
// 		// 	title: "Punch By",
// 		// 	dataIndex: "punchBy",
// 		// 	key: "punchBy",
// 		// 	render: (punchBy) => (
// 		// 		<span>
// 		// 			{punchBy[0]?.firstName + " " + punchBy[0]?.lastName || "Not Checked"}
// 		// 		</span>
// 		// 	),
// 		// },
// 		{
// 			id: 7,
// 			title: "Punch By",
// 			dataIndex: "punchBy",
// 			key: "punchBy",
// 			render: (punchBy) => (
// 				<span>
// 					{Array.isArray(punchBy) && punchBy.length > 0
// 						? `${punchBy[0]?.firstName || ""} ${punchBy[0]?.lastName || ""}`.trim()
// 						: "Self"}
// 				</span>
// 			),
// 		},

// 		// {
// 		// 	id: 6,
// 		// 	title: "Total Hour",
// 		// 	dataIndex: "totalHour",
// 		// 	key: "totalHour",
// 		// 	render: (totalHour) => totalHour || "Not Checked",
// 		// },
// 		{
// 			id: 6,
// 			title: "Total Hour",
// 			dataIndex: "totalHour",
// 			key: "totalHour",
// 			render: (totalHour) => totalHour ? totalHour.toFixed(2) : "Not Checked",
// 		},

// 		// {
// 		// 	id: 8,
// 		// 	title: "Action",
// 		// 	dataIndex: "id",
// 		// 	key: "id",
// 		// 	render: (id) => (
// 		// 		<AttendBtn
// 		// 			path={`/admin/attendance/${id}`}
// 		// 			text='View'
// 		// 			icon={<BtnViewSvg />}
// 		// 		/>
// 		// 	),
// 		// },
// 	];

// 	useEffect(() => {
// 		setColumnsToShow(columns);
// 	}, []);

// 	const columnsToShowHandler = (val) => {
// 		setColumnsToShow(val);
// 	};

// 	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
// 	// const addKeys = (arr) => {arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));
// 	const addKeys = (arr) => {
// 		if (!Array.isArray(arr)) {
// 			// console.error("Invalid data passed to addKeys:", arr);
// 			return [];
// 		}
// 		return arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));
// 	};

// 	return (
// 		<Card className='mt-5'>
// 			<div className='text-center my-2 flex justify-between'>
// 				<h5 className='department-list-title text-color-2 text-xl mb-2'>
// 					Attendance History
// 				</h5>
// 				{list && (
// 					<div>
// 						<CsvLinkBtn>
// 							<CSVLink
// 								data={list}
// 								className='btn btn-dark btn-sm mb-1'
// 								filename='attendance_user'>
// 								Download CSV
// 							</CSVLink>
// 						</CsvLinkBtn>
// 					</div>
// 				)}
// 			</div>

// 			{list && (
// 				<div style={{ marginBottom: "30px" }}>
// 					<ColVisibilityDropdown
// 						options={columns}
// 						columns={columns}
// 						columnsToShowHandler={columnsToShowHandler}
// 					/>
// 				</div>
// 			)}

// 			<Table
// 				scroll={{ x: true }}
// 				loading={loading}
// 				columns={columnsToShow}
// 				dataSource={list ? addKeys(list) : []}
// 			/>
// 		</Card>
// 	);
// }

const UserAttendance = () => {
  const { list, loading } = useSelector((state) => state.attendance);
//   const { id } = useParams("id");
  // // console.log("id", id);
  // // console.log("Redux lists state Attendance", list);
  const EmployeeId = getUserFromToken();

  const dispatch = useDispatch();

  const currentDate = dayjs(); // Keep as dayjs object
  const StartDate = currentDate.startOf("month").format("DD-MMM-YYYY");
  const EndDate = currentDate.endOf("month").format("DD-MMM-YYYY");

  // console.log("Start Date:", StartDate); // e.g., "01-04-2025"
  // console.log("End Date:", EndDate);
  // console.log("Eid:", EmployeeId);
  // useEffect(() => {
  //   dispatch(loadAttendanceByUserId({StartDate, EndDate, EmployeeId}));

  //   return () => {
  //     dispatch(clearAttendanceList());
  //   };
  // }, [EmployeeId]);

  return (
    // <UserPrivateComponent permission='readSingle-attendance'>
    <div>
      <AttendanceCalendar />
      {/* {
				!loading ? <CustomTable list={list} loading={loading} /> : <Loader
				/>
				} */}
    </div>
    // </UserPrivateComponent>
  );
};

export default UserAttendance;
